export default __webpack_public_path__ + "static/media/imperial.1e6f8a4b.png";